import React, { FC } from 'react';
import s from './brandButton.module.scss';
import lock from './img/lock.png';

type Props = {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  animateButton?: boolean;
  children?: JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const BrandButton: FC<Props> = props => {
  const { disabled, animateButton, type, children, onClick, ...rest } = props;
  return (
    <button
      className={`${s.brandButton} ${animateButton ? s.brandButton__animate : ''}`}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className={s.brandButtonContent}>
        <img src={lock} alt='image'/>
        {children}
      </span>
     
    </button>
  );
};